import { FC } from 'react';
import { X } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useBranding } from '@utils/api';
import { GuidedBookingStep } from '@contexts/GuidedBookingContext';
import LanguageSelector from '@/components/common/LanguageSelector';

interface WizardHeaderProps {
  onClose?: () => void;
  currentStep: GuidedBookingStep;
  supportedLanguages?: string[];
}

const WizardHeader: FC<WizardHeaderProps> = ({ 
  onClose, 
  currentStep, 
  supportedLanguages = [] 
}) => {
  const { branding } = useBranding();

  if (!branding) return null;

  return (
    <div className="flex items-start justify-between w-full">
      <div className="flex-1 flex flex-col items-center">
        {branding.logo && (
          <img
            src={branding.logo}
            alt={`${branding.name}'s Logo`}
            className="h-16 sm:h-20 object-contain mb-2"
          />
        )}
        
        {/* Language selector for service selection step */}
        {currentStep === 'appointmentSelection' && supportedLanguages.length > 1 && (
          <LanguageSelector supportedLanguages={supportedLanguages} />
        )}
      </div>
      
      {onClose && (
        <Button
          variant="ghost"
          size="sm"
          onClick={onClose}
          className="shrink-0 hover:bg-gray-100"
          aria-label="Close booking form"
        >
          <X className="h-4 w-4" />
        </Button>
      )}
    </div>
  );
};

export default WizardHeader;